export const floors = [
  {
    name: 'Floor',
    url: '/base/floor',
    icon: 'fa fa-cube'
  },
  {
    name: 'Create Floor',
    url: '/base/floor/create',
    icon: 'icon-plus'
  }
];
